import React from 'react';

export function addSeparatorBetweenElements(
  elementsArray: Array<React.ReactElement>,
  Separator: React.ReactElement,
): Array<React.ReactElement> {
  return elementsArray.reduce((acc: Array<React.ReactElement>, tag, index) => {
    if (index > 0 && index < elementsArray.length) {
      acc.push(
        React.cloneElement(Separator, {
          key: `separator-${index}`, // eslint-disable-line react/no-array-index-key
        }),
      );
    }
    acc.push(tag);
    return acc;
  }, []);
}

export function createRandomKey() {
  return `${String(Math.random())}-${String(new Date().getTime())}`;
}
